<ng-container *transloco="let t">
    <qm-toast></qm-toast>
</ng-container>